module.exports={
  message: {
    "View": 'View',
    "Read More":"Read More",
    "Show Less":"Show Less",
    "Close":"Close",
    "gotoPage1":"Go to Slide ",
    "gotoPage2":"",
    "Dining":"Dining",
    "Shop":"Shop",
    "Amenities":"Attractions",
    "Transportation":"Transportation",
    "Parking":"Parking",
    "Venue":"Venue",
    "From":"From",
    "From1":"",
  }
}